module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row preview-bg preview-padding"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    staticClass: "mg-sm"
  }, [_vm._v("\n            " + _vm._s(_vm.getValue('quoteName')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(this.$store.state.quote.current.quoteEndDate) ? _c('h4', {
    staticClass: "mg-md text-right"
  }, [_vm._v("\n            Pyynnön viimeinen vastausaika\n            "), _c('br'), _c('strong', [_vm._v(_vm._s(_vm.getValue('quoteEndDate')) + " klo " + _vm._s(_vm.getValue('quoteEndTime')))]), _c('br')]) : _vm._e()])]), _vm._v(" "), _c('v-quote-preview-section', [_vm._v("\n        Kuvaus\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mg-md"
  }, [_vm._v("\n        " + _vm._s(_vm.getValue('description')) + "\n      ")]), _vm._v(" "), _c('v-quote-preview-section', [_vm._v("\n        Tiedostot\n      ")]), _vm._v(" "), _c('v-panel', [_c('div', {
    slot: "body"
  }, [(_vm.loading) ? _c('v-spinner') : _vm._e(), _vm._v(" "), (!_vm.loading) ? [_vm._l((this.$store.state.quote.files), function(file) {
    return _c('div', {
      staticClass: "row nomargin voffset"
    }, [_c('div', {
      staticClass: "col-sm-9"
    }, [_c('a', {
      staticClass: "a-btn a-block",
      attrs: {
        "href": _vm.formFileUrl(file.fileId)
      }
    }, [_vm._v(_vm._s(file.fileName))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('button', {
      staticClass: "btn btn-sm pull-right btn-celestial-blue",
      on: {
        "click": function($event) {
          _vm.removeFile(file.id)
        }
      }
    }, [_c('span', {
      staticClass: "ion ion-android-close icon-spacer icon-white"
    }), _vm._v("Poista\n                ")])])])
  }), _vm._v(" "), (this.$store.state.quote.files.length == 0) ? _c('div', [_c('span', [_vm._v("Ei lisättyjä tiedostoja.")])]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1c13b633"}!./src/app/components/quote-preview-body/quote-preview-body.html
// module id = 463
// module chunks = 1